import {BarcodeInventoryItemType, BarcodeObjectType} from "../interface";

export const barcodeInventoryItemInit: BarcodeInventoryItemType = {
    newTxtNmItem: "",
    originalPrice: 0,
    sellingPrice: 0,
    newTxtStndItem: "",
    inventoryUnit: 0,
    category: "",
    safetyAmount: 0,
    changeLog: "",
    changeAmount: 0,
    fileKey: "",
    fileUrl: "",
    fileOrgname: "",
    barcode: "",
}

export const barcodeObjectInit: BarcodeObjectType = {
    itemList: []
}